import SelectOne from './SelectOne';

export default SelectOne;